import { MdOutlineAttachFile } from 'react-icons/md';
import { TicketMessageType } from 'types';

function MessageCardComp({ className, data }: { className: string; data: TicketMessageType }) {
    const targetDate = new Date(data.created_at);
    const hours = targetDate.getHours();
    const minutes = targetDate.getMinutes();
    return (
        <div className={`${className} mb-2`}>
            <p className="t-400 t-p2 mb-1">{data.text}</p>
            {data.file ? (
                <div className="flex-column mv-1">
                    {data.file.map((file) => (
                        <a target="_blank" key={file.id} href={file.file} className="center-content-y">
                            <MdOutlineAttachFile size={12} />
                            {file.id}
                        </a>
                    ))}
                </div>
            ) : null}
            <p className={`t-300 center-content-y`}>
                {hours < 10 ? `0${hours}` : hours}:{minutes < 10 ? `0${minutes}` : minutes}
            </p>
        </div>
    );
}

export default MessageCardComp;
